import React from 'react';
import PageHeader from '../components/PageHeader';

export default function Blog() {
  return (
    <div style={{ padding: '48px', maxWidth: '760px' }}>
      <PageHeader
        eyebrow="06 — Blog"
        title="Blog"
        subtitle="Thoughts, observations, half-baked ideas."
      />

      {/* Empty state */}
      <div style={{
        marginTop: '48px',
        padding: '48px 40px',
        background: 'var(--surface)',
        border: '1px solid var(--border)',
        borderRadius: '8px',
        textAlign: 'center',
      }}>
        <div style={{
          fontFamily: '"Cormorant Garamond", Georgia, serif',
          fontSize: '3rem',
          color: 'var(--border-2)',
          marginBottom: '16px',
          lineHeight: 1,
        }}>
          ✦
        </div>
        <h2 style={{
          fontFamily: '"Cormorant Garamond", Georgia, serif',
          fontSize: '1.5rem',
          color: 'var(--text)',
          margin: '0 0 12px',
        }}>
          Nothing here yet
        </h2>
        <p style={{
          fontFamily: '"Plus Jakarta Sans", system-ui, sans-serif',
          fontSize: '0.9rem',
          color: 'var(--text-3)',
          maxWidth: '380px',
          margin: '0 auto',
          lineHeight: 1.6,
        }}>
          The blog exists in theory. Whether it will ever exist in practice is a separate
          philosophical question. Not even Silvi wants to hear what I have to say, and she loves me.{' '}
          <em>(allegedly)</em>
        </p>
      </div>

      {/* Preview card — placeholder for first future post */}
      <div style={{ marginTop: '24px', opacity: 0.4 }}>
        <div style={{
          padding: '24px',
          background: 'var(--surface)',
          border: '1px solid var(--border)',
          borderRadius: '8px',
        }}>
          <div className="eyebrow" style={{ marginBottom: '8px' }}>Coming eventually</div>
          <h3 style={{
            fontFamily: '"Cormorant Garamond", Georgia, serif',
            fontSize: '1.3rem',
            color: 'var(--text)',
            margin: '0 0 8px',
          }}>
            On building things that matter
          </h3>
          <p style={{
            fontFamily: '"Plus Jakarta Sans", system-ui, sans-serif',
            fontSize: '0.8rem',
            color: 'var(--text-3)',
            margin: 0,
          }}>
            A first attempt at putting words to the question of what makes a project worth doing.
          </p>
        </div>
      </div>
    </div>
  );
}
